var render = function () {
  var _vm$resume, _vm$resume$hashTags, _vm$resume2, _vm$resume2$hashTags, _vm$resume3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !(_vm.mode == 'view' && !((_vm$resume = _vm.resume) !== null && _vm$resume !== void 0 && (_vm$resume$hashTags = _vm$resume.hashTags) !== null && _vm$resume$hashTags !== void 0 && _vm$resume$hashTags.length)) ? _c('v-sheet', [_c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v(" 해시태그 "), _vm.mode == 'form' ? _c('span', {
    staticClass: "page-text--sm grey-6--text pl-8 font-weight-regular"
  }, [_vm._v("해시태그 기능은 기업에서 지원자 검색 시 활용 할수있으니 본인을 어필하시기 위한 해시태그를 꼭 체크해주세요.")]) : _vm._e()])]), _c('v-sheet', [_c('v-divider', {
    staticClass: "primary border-2"
  }), _c('div', {
    staticClass: "pa-10 px-md-20 py-md-16"
  }, [_vm.mode == 'form' ? [_c('v-autocomplete', _vm._b({
    class: "hash-tags-".concat(_vm.className),
    attrs: {
      "items": _vm.hashTags,
      "menuProps": {
        attach: ".hash-tags-".concat(_vm.className)
      },
      "multiple": "",
      "small-chips": ""
    },
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-chip', {
          staticClass: "grey-9--text ma-2 ma-lg-4",
          attrs: {
            "outlined": "",
            "small": "",
            "label": "",
            "color": "grey-d"
          }
        }, [_vm._v(_vm._s(item))])];
      }
    }], null, false, 3584552766),
    model: {
      value: _vm.resume.hashTags,
      callback: function callback($$v) {
        _vm.$set(_vm.resume, "hashTags", $$v);
      },
      expression: "resume.hashTags"
    }
  }, 'v-autocomplete', _vm.attrs_input, false))] : [(_vm$resume2 = _vm.resume) !== null && _vm$resume2 !== void 0 && (_vm$resume2$hashTags = _vm$resume2.hashTags) !== null && _vm$resume2$hashTags !== void 0 && _vm$resume2$hashTags.length ? _c('v-chip-group', _vm._l((_vm$resume3 = _vm.resume) === null || _vm$resume3 === void 0 ? void 0 : _vm$resume3.hashTags, function (hashTag) {
    return _c('v-chip', {
      key: hashTag,
      staticClass: "grey-9--text",
      attrs: {
        "outlined": "",
        "label": "",
        "disabled": "",
        "color": "grey-d"
      }
    }, [_vm._v(" " + _vm._s(hashTag) + " ")]);
  }), 1) : _vm._e()]], 2), _c('v-divider')], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }